
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import openbg from '@/assets/jifenhuangou/lottery/popup-bg.png'
import { getExam, save, getview,addCreditParty,addAddress,relation } from '@/api/jfhl.js'
import { updateuser } from '@/api/lottery.js'
import { isAward, isAwardbefore } from '@/api/lottery'
import { getAddressDefault } from '@/api/user'
import { getRequest } from '@/libs/utils.js'
import config from '@/config/index'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XButton,
Group,
XInput
},
data() {
return {
baseUrl: config.baseUrl,
openbg:openbg,
lotid:0,
examList: {},
subjectid: [],
useroption: [],
multi:[],
partyid:this.$route.params.partyid,
paperInfoid:'',
active: 0, // 当前题数
errorList: [],
dialogText: '您获得一次抽奖机会',
dialogType: '',
btnText: '下一题',
showDialog: false,
showErrorList: false,
showAddress:false,
result: '', // 中奖结果
prize:'',
personObj:{
NAME:'',
ADDRESS:'',
MOBILE:''
}
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
mounted() {

this.view()
},
watch: {
useroption(newVaule, oldValue) {
if (newVaule.length === this.examList.length) {
this.btnText = '提交'
}
},
multi(newValue,oldValue){
}
},
methods: {

isCurrentTime(beginTime,endTime){
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if(currentTime < beginTime){
this.click = true
this.activityType = 2
this.$vux.alert.show({
content: '抽奖活动还未开始',
})
return false
}
if(currentTime >= endTime){
this.click = true
this.activityType = 3
this.$vux.alert.show({
content: '抽奖活动已结束',
})
return false
}
this.view()
this.getAddress()
},

beforeAward(){
isAwardbefore({
lotid:this.lotid,
openid:this.userid
}).then(res=>{
if(res.obj.iszhongjiang===1){
if(res.obj.item.indexOf("积分") == -1){

this.prize = res.obj.item
if(res.obj.partyuserid===""){
this.showAddress = true
}else{
this.showAddress = false
}
}
}else{
this.isawardNow()
this.getExam()
}
})
},

isAddress(){
updateuser({
lotid:this.lotid,
openid:this.userid
}).then(res=>{
if(res.obj.isaddress===2){
this.showAddress = true
}else{




}
})
},

view(){
getview({
id: this.partyid
}).then(res=>{
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
this.getExam()
})
},
getExam() {
let _this = this
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
}).then(data => {
if (data.obj.ANSWERNUM <= 0) {
this.$vux.toast.text('您今天的一次答题机会已用完请明天再来')
setTimeout(()=>{ this.$router.push({ name: 'answerRule',params:{partyid:this.partyid}}) }, 1000)
return false
}
this.examList = data.obj.SUBJECTLIST
data.obj.SUBJECTLIST.forEach(element => {
this.subjectid.push(element.SUBJECTID)
})
})
},

viewerrorlist() {
this.showDialog = false
this.showErrorList = true
},

answer() {
console.log(22)
if (this.active + 1 >= this.examList.length) {
console.log(33)
save({
paperInfoid: this.paperInfoid,
subjectid: this.subjectid.join(';'),
useroption: this.useroption.join(';'),
openid: this.accountid
}).then(data => {
if (data.obj.ISTRUE === 1) {
this.getAward()
} else {
let wt = data.obj.ERRORLIST.length
this.showDialog = true
this.dialogText =
'答对' + (this.examList.length - wt) + '题，答错' + wt + '题'
this.errorList = data.obj.ERRORLIST
this.dialogType = 'fail'
}
})
} else {
this.$set(this.useroption,this.useroption.length,this.multi.join(','))
this.multi = []
if (!this.useroption[this.active]) {
this.$vux.toast.text('请选择答案')
return false
}
this.active++
}
},
gorule(){
this.$router.push({ name: 'answerRule',params:{partyid:this.partyid}})
},
goWrong(){
this.showErrorList=false
this.$router.push({ name: 'answerRule',params:{partyid:this.partyid}})
},
gotolottery() {
this.showDialog = false
this.$router.push({ name: 'answerChoujiang',params:{partyid:this.partyid} })
},
reload() {
this.$router.go(-1)
},
isawardNow(){
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if ((data.obj.isaward === 1 && data.obj.iszhongjiang === 1)&& data.obj.item.indexOf("积分") == -1) {
this.prize = data.obj.item
this.isAddress()
}else{
this.showAddress = false
this.getExam()
}
})
},

getAward() {
let _this = this
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.isaward === 1 && data.obj.iszhongjiang === 1) {
this.prize = data.obj.item
this.dialogText = '今天您已经抽过奖了！'
this.dialogType = ''
this.showDialog = true
if(data.obj.item.indexOf("积分") == -1){
this.isAddress()
}
}else{
this.showDialog = true
this.dialogText = '恭喜您!<br>获得一次抽奖机会'
this.dialogType = 'success'
}
})
},

getAddress(){
getAddressDefault({
accountid:this.accountid,
userid:this.userid
}).then(res=>{
if(res.returnValue!==""){
this.personObj = res.returnValue
this.personObj.ADDRESS = res.returnValue.PROVINCEIDNAME+res.returnValue.CITYIDNAME+res.returnValue.COUNTYIDNAME+res.returnValue.ADDRESS
}
})
},

sumbit(){
if(this.personObj.NAME===''){
this.$vux.toast.text('请填写姓名！')
return false
}
if(this.personObj.ADDRESS===''){
this.$vux.toast.text('请填写收货地址！')
return false
}
if(this.personObj.MOBILE===''){
this.$vux.toast.text('请填写手机号码！')
return false
}
if (!/^\d{11}$/.test(this.personObj.MOBILE)) {
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
addAddress2({
userid:this.accountid,
partyid:this.partyid,
linkman:this.personObj.NAME,
phone:this.personObj.MOBILE,
address:this.personObj.ADDRESS
}).then(res=>{
this.showAddress = false
if(res.success){

relation({
partyuserid:res.obj.partyuserid,
lotid:this.lotid,
userid:this.accountid,
openid:this.userid
}).then(data=>{
if(data.success){
this.showAddress = false
this.$vux.toast.text('您的信息提交成功！')
setTimeout(()=>{ this.getExam() }, 1000)
}
})
}
}).catch(()=>{
this.showAddress = false
})
},
}
}
